var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#EFEDFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.92 34.8h-13.6a2.84 2.84 0 01-2.71-1.81 2.92 2.92 0 01-.2-1.14V21.07a.9.9 0 01.38-.79l8.75-6.86a.77.77 0 01.54-.22c.23 0 .45.08.62.22l8.75 6.87a.88.88 0 01.39.78v10.78a2.92 2.92 0 01-1.8 2.74c-.35.15-.73.22-1.12.2zM21.2 23.03h5.84a.91.91 0 01.9.6c.05.12.07.25.07.38v8.83h2.91a.91.91 0 00.92-.6.94.94 0 00.05-.39V21.56l-7.77-6.08-7.77 6.08v10.3a.94.94 0 00.59.92c.12.04.25.06.38.06h2.91V24a.94.94 0 01.6-.92.91.91 0 01.37-.06zm.98 1.96v7.85h3.88v-7.85h-3.88z",
    fill: "#624DE3"
  })));
}
export default SvgHomeAddress;